var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmail3 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "#E3FCF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1868_1862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 19.8261,
    height: 19.8261,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1868_1862)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1868_1862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 20,
    height: 19
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.33008,
    y: 10,
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1868_1862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 26.6249C12.062 26.6249 11.6894 26.47 11.3796 26.1602C11.0692 25.8498 10.9141 25.477 10.9141 25.0415V16.452C10.9141 16.1749 10.98 15.911 11.112 15.6603C11.2439 15.4096 11.4286 15.2117 11.6661 15.0665L18.0193 11.2665C18.1512 11.1874 18.2832 11.1312 18.4151 11.0979C18.547 11.0652 18.6856 11.0488 18.8307 11.0488C18.9759 11.0488 19.1144 11.0652 19.2464 11.0979C19.3783 11.1312 19.5102 11.1874 19.6422 11.2665L25.9953 15.0665C26.2328 15.2117 26.4175 15.4096 26.5495 15.6603C26.6814 15.911 26.7474 16.1749 26.7474 16.452V25.0415C26.7474 25.477 26.5925 25.8498 26.2827 26.1602C25.9724 26.47 25.5995 26.6249 25.1641 26.6249H12.4974ZM18.8307 19.8759C18.8967 19.8759 18.9627 19.8693 19.0286 19.8561C19.0946 19.8429 19.1606 19.8165 19.2266 19.777L25.0057 16.3332L19.2266 12.8895C19.1606 12.8499 19.0946 12.8235 19.0286 12.8103C18.9627 12.7971 18.8967 12.7905 18.8307 12.7905C18.7648 12.7905 18.6988 12.7971 18.6328 12.8103C18.5668 12.8235 18.5009 12.8499 18.4349 12.8895L12.6557 16.3332L18.4349 19.777C18.5009 19.8165 18.5668 19.8429 18.6328 19.8561C18.6988 19.8693 18.7648 19.8759 18.8307 19.8759ZM12.4974 25.0415H25.1641V18.0749L19.6422 21.3801C19.5102 21.4592 19.3783 21.5186 19.2464 21.5582C19.1144 21.5978 18.9759 21.6176 18.8307 21.6176C18.6856 21.6176 18.547 21.5978 18.4151 21.5582C18.2832 21.5186 18.1512 21.4592 18.0193 21.3801L12.4974 18.0749V25.0415Z",
    fill: "#1DBE8A"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email3.3c7a4d8f.svg";
export { ForwardRef as ReactComponent };